export const thousandSeparated = (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const setNumberOfDecimals = (value, decimals = 2) =>
    (Math.round(value * 100) / 100).toLocaleString('no', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: false,
    });

/* eslint-disable no-misleading-character-class */
export const validSeoPath = (str) =>
    str
        .normalize('NFD') // decomposes combined graphemes
        .replace(/[.,'\u0300-\u036f]/g, '') // remove dots, commas, apostrophes and diacritics
        .replace(/\s/gm, '+') // replace spaces
        .replace(/\//g, '+') // replace slashes
        .replace(/[Ææ]/g, 'ae') // replace ÆØÅ
        .replace(/[Øø]/g, 'o')
        .replace(/[Åå]/g, 'a')
        .replace(/[Łł]/g, 'l') // replace weird polish L
        .toLowerCase();
/* eslint-enable no-misleading-character-class */

export const formatDuration = (totalMinutes, minutesSuffix = false) => {
    if (typeof totalMinutes !== 'number' || isNaN(totalMinutes)) {
        return '-';
    }
    const hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    if (minutesSuffix && hours === 0) {
        return `${minutes}m`;
    }
    return `${hours}t ${minutes}${minutesSuffix ? 'm' : ''}`;
};
